import { lazy } from "react";

// const Home = lazy(() => import("../pages/home"));
const Registration = lazy(() => import("../pages/registertion"));
const Waiting = lazy(() => import("../pages/waiting-participint"));
const TemplateList = lazy(() => import("../pages/template"));
const Template = lazy(() => import("../pages/template/signle"));
const QuestionPage = lazy(() => import("../pages/question"));
const StartingTimerPage = lazy(() => import("../pages/starting-timer"));
const CorrectionPage = lazy(() => import("../pages/correction"));
const WinnersPage = lazy(() => import("../pages/winners/inxde"));
const SurveyPage = lazy(() => import("../pages/survey/inxde"));

const NotFound = lazy(() => import("../pages/not-found"));

export const ROUTES = {
  HOME: "/",
  LOGIN: "/registration",
  WAITING: "/waiting",
  TEMPLATE: "/templates",
  SINGLETEMPLATE: "/templates/:id",
  QUESTION: "/question",
  STARTINGTIMER: "/starting-timer",
  CORRECTION: "/correction",
  WINNERS: "/winners",
  SURVEY: "/survey",
};

export const routesConfig = [
  {
    path: ROUTES.HOME,
    component: TemplateList,
    isPrivate: true,
  },
  {
    path: ROUTES.LOGIN,
    component: Registration,
    isPrivate: false,
  },
  {
    path: ROUTES.WAITING,
    component: Waiting,
    isPrivate: true,
  },
  {
    path: ROUTES.TEMPLATE,
    component: TemplateList,
    isPrivate: true,
  },
  {
    path: ROUTES.SINGLETEMPLATE,
    component: Template,
    isPrivate: true,
  },
  {
    path: ROUTES.QUESTION,
    component: QuestionPage,
    isPrivate: true,
  },
  {
    path: ROUTES.STARTINGTIMER,
    component: StartingTimerPage,
    isPrivate: true,
  },
  {
    path: ROUTES.CORRECTION,
    component: CorrectionPage,
    isPrivate: true,
  },
  {
    path: ROUTES.WINNERS,
    component: WinnersPage,
    isPrivate: true,
  },
  {
    path: ROUTES.SURVEY,
    component: SurveyPage,
    isPrivate: true,
  },

  {
    path: "*",
    component: NotFound,
    isPrivate: false,
  },
];
